import { render, staticRenderFns } from "./direct-sales-proposals-availability.page.vue?vue&type=template&id=2c151f6f&scoped=true"
import script from "./direct-sales-proposals-availability.page.vue?vue&type=script&lang=ts"
export * from "./direct-sales-proposals-availability.page.vue?vue&type=script&lang=ts"
import style0 from "./direct-sales-proposals-availability.page.vue?vue&type=style&index=0&id=2c151f6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c151f6f",
  null
  
)

export default component.exports